export default __webpack_public_path__ + "static/media/12.6256f672.jpg";